var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gratuity-wrapper" }, [
    _c("div", { staticClass: "gratuity-title" }, [_vm._v("Gratuity")]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "gratuity-list" },
      [
        _vm._l(_vm.options, function (option) {
          return _c(
            "li",
            { key: option.id, staticClass: "gratuity-list-item" },
            [
              _c(
                "button",
                {
                  staticClass: "gratuity-option",
                  class: { active: _vm.gratuityPercent == option.value },
                  attrs: {
                    "aria-label": "Select tip " + option.label,
                    type: "button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.selectTip(option.value)
                    },
                  },
                },
                [_vm._v("\n\t\t\t\t" + _vm._s(option.label) + "\n\t\t\t")]
              ),
            ]
          )
        }),
        _vm._v(" "),
        _c("li", { staticClass: "gratuity-list-item" }, [
          _c(
            "button",
            {
              staticClass: "gratuity-option",
              class: {
                active: _vm.selectedAmount === "-1" || _vm.isCustomTip,
              },
              attrs: { "aria-label": "Select custom tip.", type: "button" },
              on: {
                click: function ($event) {
                  return _vm.selectCustomTip()
                },
              },
            },
            [_vm._v("\n\t\t\t\tOTHER\n\t\t\t")]
          ),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _vm.isCustomTip
      ? _c("div", { staticClass: "custom-gratuity" }, [
          _c("label", { attrs: { for: "custom-tip" } }, [
            _vm._v("Set Custom Tip Amount: $"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.customTipAmount,
                expression: "customTipAmount",
              },
            ],
            attrs: {
              "aria-label": `Set Custom Tip Amount $${_vm.customTipAmount}`,
              id: "custom-tip",
            },
            domProps: { value: _vm.customTipAmount },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.customTipAmount = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: {
                id: "submitTip",
                "aria-label": "Submit custom tip $" + _vm.customTipAmount,
              },
              on: {
                click: function ($event) {
                  return _vm.submitCustomTip("-1")
                },
              },
            },
            [_vm._v("\n\t\t\tSubmit\n\t\t")]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.message
      ? _c("div", { staticClass: "gratuity-message" }, [
          _vm._v(_vm._s(_vm.message)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }